export default __webpack_public_path__ + "static/media/zapier.f4693e53.png";